import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useAxiosInstance } from "../services/Interceptor";
import { getReviews } from "../services/PublicServices";
import { Rating } from "@smastrom/react-rating";

import Slider from "react-slick";
const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function Reviews() {
  const apiInstance = useAxiosInstance();
  const [data, setData] = useState([]);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const getReviewsService = async () => {
      try {
        const response = await getReviews(apiInstance, 4, 2, false);
        if (response) {
          setData(response);
        } else {
          setHasError(true);
        }
      } catch (err) {
        console.error("Failed to load reviews:", err);
        setHasError(true);
      }
    };
    getReviewsService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hasError) {
    return (
      <div className="text-white text-center py-20">
        Unable to load testimonials at the moment. Please try again later.
      </div>
    );
  }

  return (
    data &&
    data.length > 0 && (
      <>
        <div className="testimonials bg-[#1E1E1E py-20">
          <div className="mx-auto text-center">
            <div className="text-white uppercase text-4xl md:text-5xl font-black italic mb-6 text-center">
              Testimonials
            </div>
          </div>

          <div className="flex flex-row mx-auto justify-between">
            <div className="container mx-auto">
              <div className="slider-container">
                <Slider {...settings}>
                  {data.map((item, key) => (
                    <div className={`${key === 0 ? "" : "ml-0"}`} key={key}>
                      <div className="text-white mt-10 px-10">
                        {/* New */}

                        <div className="bg-black text-white p-6 rounded-2xl max-w-sm mx-auto sm:max-w-md md:max-w-lg lg:max-w-xl">
                          <div className="flex flex-col items-center text-center space-y-3">
                            {/* Avatar */}
                            <img
                              alt="Trackit"
                              src={item.profilePicture || "/image6.png"}
                              className="w-20 h-20 rounded-full object-cover"
                            ></img>

                            {/* Title */}
                            <h3 className="text-lg font-bold italic uppercase line-clamp-1 overflow-hidden">
                              {item.reviewTitle}
                            </h3>

                            {/* Testimonial Text */}
                            <p className="text-sm sm:text-base line-clamp-2 overflow-hidden min-h-10">
                              {item.reviewText}
                            </p>

                            {/* Rating */}
                            <Rating
                              style={{ maxWidth: 250 }}
                              value={item.numberOfStars}
                              readOnly
                            />

                            {/* Name */}
                            <p className="text-white font-semibold text-base">
                              - {item.userFullName}
                            </p>
                          </div>
                        </div>

                        {/* New */}
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
}
